import React, { useEffect, useState, Suspense } from "react";
import { Link, useNavigate } from "react-router-dom";

import AllFeatureDataTable from "../../../GuiComponents/AllFeatureDataTable.table";

import userStore from "../../../zustand/userStore";
import axios from "axios";
import "../events/events-responsive.css";
import { toast } from "react-toastify";
import { getUploadedDocumentDetails } from "../../../configs/WebService";
import { apiKeyHeader } from "../../../configs/ApiKeys";

const UploadedDocuments = () => {
  const navigate = useNavigate();
  const userData = userStore((state) => state.user);
  const [processedEvents, setProcessedEvents] = useState([]);
  useEffect(() => {
    if (userData?.id) {
      getUploads();
    }
  }, [userData]);

  const getUploads = async () => {
    try {
      const userId = userData?.id;

      const response = await axios.get(`${getUploadedDocumentDetails}${userId}`, {
        headers: apiKeyHeader(),
      });

      const data = response?.data;
      if (!data) {
        toast.error("Failed to fetch events");
        return;
      }
      console.log("Fetched Data:", data);

      const formatted = processData(data);
      setProcessedEvents(formatted);
    } catch (error) {
      toast.error(error.message || "Failed to fetch events");
    }
  };

  const dataTableColumns = [
    { Header: "#", accessor: "sno" },
    { Header: "Event Name", accessor: "name" },
    { Header: "Activity Name", accessor: "activity" },
    { Header: "Number of Files Uploaded", accessor: "number_of_files" },
    { Header: "Actions", accessor: "actiontd" },
  ];

  const processData = (eventsArray) => {
    let serial = 1;
    const rows = [];

    eventsArray.forEach((event) => {
      rows.push({
        sno: serial++,
        name: event.event_name,
        activity: event.activity_name,
        number_of_files: event.files?.length || 0,
        actiontd: (
          <i
            title="View Details"
            className="fa fa-eye mx-2"
            style={{ color: "blue", cursor: "pointer" }}
            onClick={() =>
              navigate("/viewUploadedDocuments", {
                state: {
                  event: event.event_name,
                  activity: event.activity_name,
                  files: event.files || [],
                },
              })
            }
          ></i>
        ),
      });
    });

    return rows;
  };

  return (
    <Suspense fallback={<>Loading...</>}>
      <div className="main_container upload-documents-wrapper px-5">
        {/* <Sidebar />
        <Navbar /> */}
        <div className="right_col" role="main">
          <div className="row">
            <div className="col-md-12 col-sm-12">
              <div
                className="x_panel"
                style={{ height: "80vh", overflow: "auto" }}
              >
                <div className="x_title">
                  <div className="clearfix d-flex justify-content-between align-items-center">
                    <Link to="/uploadDocuments">
                      <button className="btn btn-primary btn-sm">
                        Upload Documents <i className="fa fa-plus"></i>
                      </button>
                    </Link>
                  </div>
                </div>
                <div className="x_content">
                  {processedEvents.length > 0 ? (
                    <div className="table-responsive">
                      <AllFeatureDataTable
                        columns={dataTableColumns}
                        data={processedEvents}
                      />
                    </div>
                  ) : (
                    <p>No Events Found</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <Footer /> */}
      </div>
    </Suspense>
  );
};

export default UploadedDocuments;
